import { Box, Container, SxProps, Theme, Typography, useTheme } from '@mui/material';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useTranslation } from 'react-i18next';
import Button from '../Button/Button';
interface ErrorScreenProps {
  message?: string | null;
  icon?: any;
  onRetry?: () => void;
  error?: Error;
  onReset?: () => void;
}

const styles: Record<string, SxProps<Theme>> = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    textAlign: 'center',
    padding: 3,
  },
  image: {
    marginBottom: 4,
    borderRadius: 2,
    overflow: 'hidden',
  },
  message: {
    marginBottom: 4,
  },
};

export default function ErrorScreen({ message, icon, error, onReset, onRetry }: ErrorScreenProps) {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Container sx={styles.root} maxWidth="md">
      <Box>
        {icon ?
          <Box sx={styles.image}>
           {icon}
          </Box> :
          <ErrorOutlineIcon sx={{ fontSize: 80, color: theme.palette.error.main }} />
        }
        <Typography variant="h4" component="h1" gutterBottom>
          {t('errorScreen.title', 'Oops! Something went wrong.')}
        </Typography>
        <Typography variant="body1" sx={styles.message}>
          {message || error?.message || t('errorScreen.defaultMessage', 'We encountered an unexpected error. Please refresh the page or try again later.')}
        </Typography>
        {(onRetry || onReset) && (
          <Button variant="contained" onClick={onRetry || onReset}>
            {t('errorScreen.retry', 'Try Again')}
          </Button>
        )}
      </Box>
    </Container>
  );
}

